import { render, staticRenderFns } from "./BidsList.vue?vue&type=template&id=463d68c3"
import script from "./BidsList.vue?vue&type=script&lang=js"
export * from "./BidsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports